import * as yup from 'yup';
import { isEmailRequiredForUserRole } from '../userRoleUtils';

export const AddUserSchema = yup.object().shape({
  role: yup
    .string()
    .oneOf(['admin', 'owner', 'manager', 'operator', 'employee'], 'Invalid role')
    .required('Role is required'),
  can_approve_reconciliation: yup.boolean().default(false),
  name: yup
    .string()
    .required('Name is required')
    .matches(/^[a-zA-Z ]+$/, 'Name must contain only letters and spaces')
    .min(3, 'Name must be at least 3 characters')
    .max(30, 'Name cannot exceed 30 characters'),
  email: yup
    .string()
    .when('role', {
      is: isEmailRequiredForUserRole,
      then: (schema) => schema
        .required('Email is required')
        .email('Please enter a valid email address'),
      otherwise: (schema) => schema
        .nullable()
        .email('Please enter a valid email address'),
    }),
  phone_number: yup
    .string()
    .default('')
    .test('phone-format', 'Phone number must be 10 digits', (value) => {
      return !value || /^\d{10}$/.test(value);
    }),
  cashier_mode_pin: yup
    .string()
    .default('')
    .test('pin-format', 'Cashier-mode PIN must be exactly 6 digits', (value) => {
      return !value || /^\d{6}$/.test(value);
    })
    .when(['role', 'phone_number'], {
      is: (role: string, phoneNumber: string) => role === 'operator' && !phoneNumber,
      then: (schema) => schema
        .required('Cashier-mode PIN is required when phone number is blank')
        .matches(/^\d{6}$/, 'Cashier-mode PIN must be exactly 6 digits'),
      otherwise: (schema) => schema.notRequired(),
    }),
});
